import { ICellRenderer } from 'ag-grid-community';
import { compareDates } from './resourceTimelineUtilities';
import Plane16 from '@carbon/icons/es/plane/16';
import Calendar16 from '@carbon/icons/es/calendar/16';

export default class TimesheetsCellRenderer implements ICellRenderer {
  private eGui: HTMLElement;
  private params: any;
  private clickListener: () => void;
  private icon: any; // Use appropriate type
  node;

  btnClickedHandler() {
    this.params.clicked(this.params);
  }

  public init(params: any): void {
    this.node = params.node;
    this.params = params;
    this.eGui = document.createElement('div');
    this.btnClickedHandler = this.btnClickedHandler.bind(this);
    params.eGridCell.style.justifyContent = 'center';
    let displayValue = null;
    if (params?.value) {
      if (params.value?.hours) {
        //if an hours value
        displayValue = params.value.hours.toFixed(2) + 'h';
      } 
      // else if (params.value?.expectedHours) {
      //   //if no hours but expected hours
      //   displayValue = params.value.expectedHours.toFixed(1) + 'h';
      //   params.eGridCell.style.fontStyle = 'italic';
      // } 
      else {
        displayValue = typeof params?.value !== 'object' ? `${params?.value.toFixed(2)}h ` : null;
      }
      this.eGui.innerHTML = displayValue;
      
      if (!(params.value?.hours === 0 && params.value?.expectedHours === 0 )) {
        if (params.node.level === 0 || params.node.level === 1){
          const diff = params.value?.hours - params.value?.expectedHours;
          if (diff === 0) {
            params.eGridCell.style.backgroundColor = 'rgba(76, 175, 80, 0.2)'; //exact
          } else if (diff > 0) {
            params.eGridCell.style.backgroundColor = 'rgba(255, 152, 0, 0.2)'; //overtime
          } else {
            params.eGridCell.style.backgroundColor = 'rgba(33, 150, 243, 0.2)'; //under
          }
        }
        
      }
      if (this.node.level === 0) {
        params.eGridCell.style.fontWeight = 600;
        params.eGridCell.style.backgroundColor = params.eGridCell.style.backgroundColor.replace(/[^,]+(?=\))/, '0.45');

        params?.timeBankTransactionData?.forEach(group =>{
          group?.timeOffRequestGroupTimeOffRequest?.forEach((request)=>{
            if(compareDates(request?.date, params?.colDef?.pivotKeys[0]) ){
              let icon = document.createElement("span");
              icon.innerHTML = '<stencil-icon-button></stencil-icon-button>';
              icon.style.position = 'absolute'
              icon.style.top = "-10px"
              icon.style.right = "-8px"
              this.icon = icon.querySelector('stencil-icon-button');
              this.icon.noBackground = true;
              this.icon.noTooltip = true;
              //if(transaction?.timeBankEntryName === "Vacation"){
              this.icon.icon = Plane16
              //}
              //else{
                //this.icon.icon = Heart16
              //}
              this.eGui.appendChild(icon)
            }
          })
          
        })

        params?.holidayData?.forEach(transaction =>{
          transaction?.holidayCalendarHolidayCalendarDay?.forEach(day =>{
            if(compareDates(day?.date, params?.colDef?.pivotKeys[0]) ){
              let icon = document.createElement("span");
              icon.innerHTML = '<stencil-icon-button></stencil-icon-button>';
              icon.style.position = 'absolute'
              icon.style.top = "-10px"
              icon.style.right = "-8px"
              this.icon = icon.querySelector('stencil-icon-button');
              this.icon.noBackground = true;
              this.icon.noTooltip = true;
              this.icon.icon = Calendar16
              this.eGui.appendChild(icon)
            }
          })
        })
      }
    }
    

    params.eGridCell.addEventListener('click', this.btnClickedHandler);
    params.eGridCell.style.cursor = 'pointer';

  }

  public getGui(): HTMLElement {
    return this.eGui;
  }

  public refresh(): boolean {
   return false
  }

  public destroy(): void {
    // Cleanup: remove the click event listener
    if (this.eGui && this.clickListener) {
      this.eGui.removeEventListener('click', this.clickListener);
    }
  }
}
